import { render, staticRenderFns } from "./ConvitesClube.vue?vue&type=template&id=4f3a6584"
import script from "./ConvitesClube.vue?vue&type=script&lang=ts"
export * from "./ConvitesClube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports